<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid v-if="empresa">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px;">
              <v-img v-if="this.$vuetify.breakpoint.lg && carregamento != 'EVENTO_NÃO_LOCALIZADO'" height="300px" :src="`${imagemBanner}`" :gradient="empresa.topoGradiente == true ? 'to top right, rgba(3, 3, 3, .60), rgba(3, 3, 3, .7)' : ''">
                <div style="position: relative; top: 50%; transform: translateY(-50%); text-align: center">
                  <h2 style="color: #ffffff" v-if="empresa.exibirTitulo">{{empresa.nome}}</h2>
                  <p style="color: #ffffff" v-if="empresa.exibirSubTitulo">{{empresa.descricao}}</p>
                </div>
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-img v-if="!this.$vuetify.breakpoint.lg && carregamento != 'EVENTO_NÃO_LOCALIZADO'" height="100%" :src="`${imagemBanner}`" :gradient="empresa.topoGradiente == true ? 'to top right, rgba(3, 3, 3, .60), rgba(3, 3, 3, .7)' : ''">
                <div style="position: relative; top: 50%; transform: translateY(-50%); text-align: center">
                  <h2 style="color: #ffffff" v-if="empresa.exibirTitulo">{{empresa.nome}}</h2>
                  <p style="color: #ffffff" v-if="empresa.exibirSubTitulo">{{empresa.descricao}}</p>
                </div>
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <div style="margin: 5px; padding: 5px; text-align: center" v-if="carregamento == 'CARREGADO'">
                <v-card outlined>
                  <v-card-text>
                    <p style="text-align: center; margin-bottom: 12px; font-size: 20px">Olá, {{convidado.nome}}!</p>
                  </v-card-text>
                  <v-card-actions class="login-title" style="margin-top: -20px" v-if="!convidado.horaConfirmacao">
                    <p>Confirma sua presença?</p>
                    <v-btn dark color="green" @click="confirmaPresenca(true)">SIM</v-btn>
                    <v-btn dark color="red" @click="confirmaPresenca(false)">NÃO</v-btn>
                  </v-card-actions>
                  <v-card-text>
                    <p>
                      <v-icon left>mdi-map-marker-outline</v-icon>
                      <b>Local: </b>{{ empresa.endereco }}
                    </p>
                    <p>
                      <v-icon left>mdi-calendar-outline</v-icon>
                      <b>Data e horário: </b>{{ empresa.data }} <b>às</b> {{ empresa.horario }}
                    </p>
                    <p v-if="convidado.senhasExtra && convidado.senhasExtra > 0">
                      <v-icon left>mdi-ticket-confirmation-outline</v-icon>
                      <b>Senhas extras: </b>{{ convidado.senhasExtra }}
                    </p>
                  </v-card-text>
                  <v-card-actions class="login-title" style="margin-top: -20px" v-if="convidado.horaConfirmacao">
                    <v-alert outlined style="margin-bottom: 0px" v-if="convidado.confirmacao && convidado.horaConfirmacao">
                      <qrcode-vue :value="convidado.codigo" size="100" level="H" background="#ffffff" foreground="#000000"></qrcode-vue>
                      <p style="margin-top: 12px; margin-bottom: 0px">Apresente o QRCode acima para ingressar no evento.</p>
                    </v-alert>
                    <v-alert :color="convidado.confirmacao == true ? 'success' : 'error'" dense dark style="margin-bottom: 0px; margin-top: 10px" v-if="convidado.horaConfirmacao">
                      <p style="font-size: 10px; margin: 0px">Confirmação efetuada em {{ transformaData(convidado.horaConfirmacao, 'DD/MM/YYYY') }} às {{ transformaData(convidado.horaConfirmacao, 'HH:mm:ss') }}.</p>
                    </v-alert>
                    <v-alert color="success" dense dark style="margin-bottom: 0px; margin-top: 10px" v-if="convidado.checkin">
                      <p style="font-size: 10px; margin: 0px">Check-in efetuado em {{ transformaData(convidado.checkin, 'DD/MM/YYYY') }} às {{ transformaData(convidado.checkin, 'HH:mm:ss') }} por {{ convidado.userValidatorCheckin.nome }}.</p>
                    </v-alert>
                    <v-alert color="success" dense dark style="margin-bottom: 0px; margin-top: 10px" v-if="horaPresentes.length > 0">
                      <span v-for="hora in horaPresentes" :key="hora.id">
                        <p style="font-size: 10px; margin: 0px">{{ hora.horaPresente }}</p>
                      </span>
                    </v-alert>
                  </v-card-actions>
                </v-card>
              </div>
              <div style="margin: 5px; padding: 5px;" v-if="carregamento == 'CARREGADO' && presentes.length > 0 && empresa.listaPresentes">
                <v-card outlined>
                  <p style="margin-top: 10px; margin-bottom: 0px; font-size: 1.25rem; text-align: center">Lista de Presentes</p>
                  <v-container fluid style="padding: 0px">
                    <v-row style="margin: 0px; padding-top: 0px">
                      <v-col cols="12" xs="6" sm="6" md="4" lg="4" v-for="presente in presentes" :key="presente.id" justify-center>
                        <v-card>
                          <v-img width="100%" height="100%" max-height="200px" contain :src="presente.urlImagem"></v-img>
                          <v-divider></v-divider>
                          <v-list dense>
                            <v-list-item style="text-align: left; height: 60px">
                              <v-list-item-content><b>{{ presente.descricao }}</b></v-list-item-content>
                            </v-list-item>
                            <v-list-item style="text-align: left; height: 60px">
                              <v-list-item-content>{{ presente.detalhes }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>R$ {{ presente.preco }} (em 6x de R$ {{ calculaValorParcelado(presente.preco, 6) }})</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-btn color="success" v-if="!presente.naLista" @click="adicionaItem(presente)">
                                  <v-icon left>add_circle</v-icon>Adicionar Item
                                </v-btn>
                                <v-btn color="error" v-else @click="removeItem(presente)">
                                  <v-icon left>remove_circle</v-icon>Remover Item
                                </v-btn>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </div>
              <div style="margin: 5px; padding: 5px; text-align: center" v-if="carregamento == 'EVENTO_NÃO_LOCALIZADO'">
                <v-icon size="50" style="margin-top: 5px">mdi-alert</v-icon>
                <p style="margin-bottom: 5px">Evento não localizado</p>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-footer dark padless class="footer" app v-if="pedido.itensPedido.length > 0">
          <v-card class="flex" flat tile color="#37474F">
            <v-card-title>
              <span>
                Total: R$ <strong class="subheading">{{pedido.valor}}</strong>
              </span>
              <v-spacer></v-spacer>
              <v-btn class="ma-2" color="teal" @click="continuaCompra">Continuar</v-btn>
            </v-card-title>
          </v-card>
        </v-footer>

        <v-dialog fullscreen persistent v-model="dialogoCompra" transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="teal">
              <v-toolbar-title>Resumo da compra</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text @click="dialogoCompra = false" :disabled="mostraCamposCartao">Voltar</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <div v-if="pedido.itensPedido.length > 0">
              <!-- <v-card v-for="item in pedido.itensPedido" :key="item.produtoId" tile outlined>
                <v-row>
                  <v-col cols="9" xs="9" sm="9" md="9" lg="9" align-self="center">
                    <v-card-title class="text-h6" v-text="item.descricao" style="font-weight: bold; color: #37474F; padding-bottom: 0px"></v-card-title>
                    <v-card-subtitle v-text="item.detalhes" style="padding-bottom: 0px; margin-top: 0px"></v-card-subtitle>
                  </v-col>
                  <v-col cols="3" xs="3" sm="3" md="3" lg="3" align-self="center" style="text-align: center;">
                    <h4 style="color: #00BFA5; font-weight: bold;">R$ {{item.preco}}</h4>
                  </v-col>
                </v-row>
              </v-card> -->
              <v-virtual-scroll :items="pedido.itensPedido" item-height="65" height="300" :bench="pedido.itensPedido.length">
                <template v-slot:default="{ item }">
                  <v-list-item style="border: 1px #ddd solid">
                    <v-list-item-avatar tile>
                      <v-avatar tile>
                        <v-img :src="item.urlImagem" contain height="100%"></v-img>
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.descricao }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.detalhes }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-list-item-subtitle style="color: #00BFA5; font-weight: bold;">R$ {{ item.preco }}</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </div>
            <v-footer dark v-if="exibeFooterResumo" app fixed color="#37474F" transition="dialog-bottom-transition">
              <v-row dense v-if="!mostraCamposCartao">
                <v-col cols="12" sm="12" md="12" lg="12" xs="12" xl="12" align-self="center">
                  <v-card class="flex" flat tile color="#37474F">
                    <v-card-text class="text-h5 py-1 white--text text-center" style="font-size: 22px">
                      <span>Total: <strong class="subheading">R$ {{pedido.valor}}</strong></span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" xs="12">
                  <v-btn block large color="#00838F" @click="mostraCamposCartao = true">
                    <v-icon left>payment</v-icon>Crédito
                  </v-btn>
                </v-col>
                <v-col cols="12" xs="12">
                  <v-btn block large color="#00838F" @click="dialogoPedeCPF('PIX')">
                    <v-icon left>qr_code</v-icon>Pix
                  </v-btn>
                </v-col>
                <v-col cols="12" xs="12">
                  <v-btn block large color="#00838F" @click="dialogoPedeCPF('BOLETO')">
                    <v-icon left>local_atm</v-icon>Boleto
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense v-if="mostraCamposCartao">
                <v-row>
                  <v-col cols="12" xs="6" sm="12" md="12" lg="8">
                    <v-text-field v-model="cobrancaAsaasCartao.creditCard.holderName" outlined dense label="Nome impresso no cartão*" hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                    <v-text-field v-model="cobrancaAsaasCartao.creditCard.number" outlined dense label="Número do cartão*" v-mask="'#### #### #### ####'" type="tel" hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="3">
                    <v-text-field v-model="cobrancaAsaasCartao.creditCard.cpfCnpj" outlined dense label="CPF do titular*" v-mask="'###.###.###-##'" v-validate="'required|cpf'" :error-messages="errors.collect('cpftitular')" data-vv-name="cpftitular" type="tel" hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="2">
                    <v-text-field v-model="cobrancaAsaasCartao.creditCard.ccv" outlined dense label="CVV*" v-mask="'###'" type="password" hide-details></v-text-field>
                  </v-col>
                  <v-col cols="6" xs="6" sm="6" md="12" lg="2">
                    <v-select v-model="cobrancaAsaasCartao.creditCard.expiryMonth" outlined dense label="Mês de vencimento*" hide-details :items="mesesVencimento" item-text="titulo" item-value="id"></v-select>
                  </v-col>
                  <v-col cols="6" xs="6" sm="6" md="12" lg="2">
                    <v-select v-model="cobrancaAsaasCartao.creditCard.expiryYear" outlined dense label="Ano de vencimento*" hide-details :items="anosVencimento" item-text="titulo" item-value="id"></v-select>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="3">
                    <v-select v-model="bandeiraCartao" outlined dense :items="bandeiras" hide-details item-text="text" item-value="value" label="Bandeira*"></v-select>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-select v-model="cobrancaAsaasCartao.value" outlined dense :items="parcelas" hide-details item-text="text" item-value="value" label="Parcelas*" @input="carregaQtdParcelas"></v-select>
                  </v-col>
                  <v-col cols="6" xs="12" sm="12" md="12" lg="4">
                    <v-text-field v-mask="'#####-###'" v-model="cobrancaAsaasCartao.creditCardHolderInfo.postalCode" label="CEP*" outlined type="tel" dense hide-details required></v-text-field>
                  </v-col>
                  <v-col cols="6" xs="12" sm="12" md="12" lg="4">
                    <v-text-field v-model="cobrancaAsaasCartao.creditCardHolderInfo.addressNumber" label="Nº do Endereço*" outlined type="tel" dense hide-details required></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                    <v-text-field v-model="cobrancaAsaasCartao.creditCardHolderInfo.email" label="E-mail*" outlined type="mail" dense hide-details required></v-text-field>
                  </v-col>
                  <v-col cols="6" xs="12" sm="12" md="12" lg="6">
                    <v-btn dark block @click="mostraCamposCartao = false" color="red">Voltar</v-btn>
                  </v-col>
                  <v-col cols="6" xs="12" sm="12" md="12" lg="6">
                    <v-btn dark block @click="pagamentoCartao" color="green">Pagar</v-btn>
                  </v-col>
                </v-row>
              </v-row>
            </v-footer>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoBoleto" persistent max-width="600px">
          <v-card>
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">{{msgResultado}}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#FF0000">Após um dia útil, seu boleto será compensado e o valor será recebido.</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 2px;">
                    <v-btn style="border-radius: 7px;" dark color="#7b4f44" depressed @click="abreBoleto">Visualizar Boleto</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="pagamentoPix" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 4px;">
              <span class="texto">QR Code</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 1px;">
                    <img :src="qrCode64" width="300px">
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 1px;">
                    <p class="texto" style="color:orange">R$ {{(parseFloat(cobrancaAsaas.value)).toFixed(2).replace('.',',')}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 1px;">
                    <p class="texto" style="color:#00695C">Nome Fantasia: INTELITE TECNOLOGIA</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 1px;">
                    <p class="texto" style="color:#00695C">Solicitação Pagador: {{ empresa.nome }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 1px; position: absolute; left: -99999px;">
                    <v-text-field id="chavePix" v-model="chaveCopiaeCola"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 1px;">
                    <v-btn dark depressed color="#00695C" @click="doCopy('chavePix')">Copiar Chave</v-btn>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 1px;">
                    <br>
                    <p class="texto">Faça a leitura do QR Code ou copie a chave e cole no aplicativo de seu banco na função "Pix Copia e Cola". Realize o pagamento e aguarde a confirmação. Pode levar até 02 (dois) minutos.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="closeDialog">Finalizar</v-btn>
            </v-card-actions> -->
          </v-card>
        </v-dialog>

        <v-dialog persistent v-model="dialogoInformarCPF" max-width="300px">
          <v-card>
            <v-card-title>Informe seu CPF</v-card-title>
            <v-card-text>
              <v-text-field v-model="clienteAsaas.cpfCnpj" outlined dense hide-details v-mask="'###.###.###-##'" type="tel" label="CPF" v-validate="'required|cpf'" :error-messages="errors.collect('cpftitular')" data-vv-name="cpftitular"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialogoInformarCPF = false" text color="error">Fechar</v-btn>
              <v-btn @click="prosseguirPagamento" text color="primary">Continuar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" persistent max-width="400px">
          <v-card>
            <v-card-text style="text-align: center; padding: 0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <v-icon color="success" size="100">check_circle</v-icon>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color: #666">Compra realizada com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  /* import vueCard from 'vue-card-express'; */
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import CpfValidate from '../../componentes/validators/rules/cpf'
  import QrcodeVue from 'qrcode.vue'
  import { baseApiUrl, /* modelBoleto */ } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import {
    mapState
  } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    components: { Snackbar, QrcodeVue, Loading },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        timeout: 4000,
        snackbar: false,
        textoSnackbar: '',
        pagamentoPix: false,
        dialog: false,
        confirmacaoBoleto: false,
        mesesVencimento: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        anosVencimento: [],
        bandeiras: [
          {value: 'DINERS', text: "DINERS"},
          {value: 'ELO', text: "ELO"},
          {value: 'HIPERCARD', text: "HIPERCARD"},
          {value: 'MASTERCARD', text: "MASTERCARD"},
          {value: 'VISA', text: "VISA"}
        ],
        parcelas: [],
        cobrancaAsaas: {
          customer: '',
          billingType: '',
          value: 0,
          dueDate: '',
          description: ''
        },
        cobrancaAsaasCartao: {
          customer: '',
          billingType: '',
          value: 0,
          dueDate: '',
          description: '',
          remoteIp: '',
          creditCard: {
            holderName: '',
            number: '',
            expiryMonth: '',
            expiryYear: '',
            ccv: ''
          },
          creditCardHolderInfo: {
            name: '',
            email: '',
            cpfCnpj: '',
            postalCode: '',
            addressNumber: '',
            phone: ''
          }
        },
        clienteAsaas: {
          name: '',
          cpfCnpj: '',
          email: '',
          mobilePhone: '',
          postalCode: '',
          addressNumber: '',
          notificationDisabled: true,
        },
        qrCode64: '',
        chaveCopiaeCola: '',
        isLoading: false,
        fullPage: true,
        msgResultado: '',
        idPedido: '',
        idClienteAsaas: '',
        verificaCodInscricao: 0,
        linkBoleto: '',
        imagemBanner: '',
        convidado: {
          codigo: '',
          nome: '',
          whatsapp: '',
          confirmacao: false,
          presenteou: false,
          empresaId: '',
        },
        empresa: {
          nome: '',
          cnpj: '',
          endereco: '',
          telefone: '',
          descricao: '',
          data: '',
          horario: '',
          imagemUrl: '',
          listaPresentes: null
        },
        carregamento: '',
        presentes: [],
        pedido: {
          statusPedido: "EM ANÁLISE",
          formaPagamento: "",
          statusPagamento: "PENDENTE",
          valor: 0.00,
          desconto: "",
          empresaId: "",
          convidadoId: "",
          itensPedido: [],
          created: ''
        },
        dialogoCompra: false,
        exibeFooterResumo: false,
        mostraCamposCartao: false,
        dialogoInformarCPF: false,
        bandeiraCartao: '',
        formaPagamento: '',
        horaPresentes: [],
        dictionary: {
          custom: {
            nomeCartao: {
              required: () => 'Informe o nome'
            },
            numCartao: {
              required: () => 'Informe o número do cartão de crédito',
            },
            cpftitular: {
              required: () => 'Informe o número do cartão de crédito',
            },
            codCartao: {
              required: () => 'Informe o código de segurança'
            },
            expiraCartaoMes: {
              required: () => 'Informe o mês de validade do cartão',
            },
            expiraCartaoAno: {
              required: () => 'Informe o ano de validade do cartão',
            },
            dateOfBirth: {
                required: () => 'Informe a Data de Nascimento' ,
                date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
            },
          }
        }
      }
    },

    watch: {
      'pedido.itensPedido'() {
        this.pedido.valor = 0.00
        for (let i = 0; i < this.pedido.itensPedido.length; i++) {
          this.pedido.valor += parseFloat(this.pedido.itensPedido[i].preco.replace(',','.'))
        }
        this.pedido.valor = this.pedido.valor.toFixed(2).replace('.',',')
      }
    },
    
    mounted: function () {
      this.pegaParametrosUrl()
      this.$validator.localize('pt', this.dictionary)
    },

    methods: {
      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      reloadPage() {
        window.location.reload()
      },

      async carregaEmpresa(idEmpresa) {
        await axios.get(baseApiUrl + 'Empresas/' + idEmpresa).then(response => {
          if (response.data) {
            if (response.data.situacao == 'ATIVO') {
              if (response.data.listaPresentes) {
                this.carregaPresentes(this.convidado.empresaId)
              }
              this.empresa = response.data
              this.imagemBanner = response.data.imagemUrl
              this.carregamento = 'CARREGADO'
            } else {
              this.carregamento = 'EVENTO_NÃO_LOCALIZADO'
            }
          }
        })
      },

      criarParcelas() {
        this.parcelas = []
        for (let i = 0; i < this.empresa.quantidadeParcelas; i++) {
          if ((i + 1) == 1) {
            this.parcelas.push({
              "text": i+1 + 'X de R$ ' + parseFloat(this.pedido.valor.replace(',','.')).toFixed(2).replace('.',',') + " (Total R$ " + parseFloat(this.pedido.valor.replace(',','.')).toFixed(2).replace('.',',') + ")",
              "value": parseFloat(this.pedido.valor.replace(',','.')).toFixed(2),
              "parcela": i+1
            })
          } else if ((i + 1) == 2) {
            this.parcelas.push({
              "text": i+1 + 'X de R$ ' + ((parseFloat(this.parcelas[i-1].value) + parseFloat(this.parcelas[i-1].value * ((this.empresa.porcentagemCobrada + (this.empresa.porcentagemCobrada / 2)) / 100))) / (i + 1)).toFixed(2).replace('.',',') + " (Total R$ " + (parseFloat(this.parcelas[i-1].value) + parseFloat(this.parcelas[i-1].value * ((this.empresa.porcentagemCobrada + (this.empresa.porcentagemCobrada / 2)) / 100))).toFixed(2).replace('.',',') + ")",
              "value": (parseFloat(this.parcelas[i-1].value) + parseFloat(this.parcelas[i-1].value * ((this.empresa.porcentagemCobrada + (this.empresa.porcentagemCobrada / 2)) / 100))).toFixed(2).replace(',','.'),
              "parcela": i+1
            })
          } else {
            this.parcelas.push({
              "text": i+1 + 'X de R$ ' + ((parseFloat(this.parcelas[i-1].value) + parseFloat(this.parcelas[i-1].value * (this.empresa.porcentagemCobrada / 100))) / (i + 1)).toFixed(2).replace('.',',') + " (Total R$ " + (parseFloat(this.parcelas[i-1].value) + parseFloat(this.parcelas[i-1].value * (this.empresa.porcentagemCobrada / 100))).toFixed(2).replace('.',',') + ")",
              "value": (parseFloat(this.parcelas[i-1].value) + parseFloat(this.parcelas[i-1].value * (this.empresa.porcentagemCobrada / 100))).toFixed(2).replace(',','.'),
              "parcela": i+1
            })
          }
        }
      },

      carregaQtdParcelas() {
        for (let i = 0; i < this.parcelas.length; i++) {
          if (this.cobrancaAsaasCartao.value == this.parcelas[i].value) {
            this.cobrancaAsaasCartao.installmentCount = this.parcelas[i].parcela
          }
        }
      },

      async atualizaPedido(callback = null) {
        try {
          await axios.patch(baseApiUrl + 'Pedidos/' + this.idPedido, this.pedido )
          if (callback) {
            callback()
          }
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao atualizar cadastro, tente novamente", "DESCULPE")
        }
      },

      async pagamentoCartao() {
        if ((this.cobrancaAsaasCartao.creditCard.holderName != '') && (this.cobrancaAsaasCartao.creditCard.number != '') && (this.cobrancaAsaasCartao.creditCard.cpfCnpj != '') && (this.cobrancaAsaasCartao.creditCard.ccv != '') && (this.cobrancaAsaasCartao.creditCard.expiryMonth != '') && (this.cobrancaAsaasCartao.creditCard.expiryYear != '') && (this.bandeiraCartao != '') && (this.cobrancaAsaasCartao.value != '') && (this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode != '') && (this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber != '') && (this.cobrancaAsaasCartao.creditCardHolderInfo.email != '')) {
          this.isLoading = true
          await this.salvarPedido('CARTAO')
          this.clienteAsaas.cpfCnpj = this.cobrancaAsaasCartao.creditCard.cpfCnpj
          await this.criarClienteAsaas()
          if (this.idPedido) {
            try {
              this.cobrancaAsaasCartao.customer = this.idClienteAsaas
              this.cobrancaAsaasCartao.billingType = 'CREDIT_CARD'
              this.cobrancaAsaasCartao.installmentValue = parseFloat(parseFloat(this.cobrancaAsaasCartao.value) / this.cobrancaAsaasCartao.installmentCount)
              this.cobrancaAsaasCartao.dueDate = moment().format('YYYY-MM-DD')
              this.cobrancaAsaasCartao.description = 'Ref. aos presentes para ' + this.empresa.nome
              this.cobrancaAsaasCartao.pedidoId = this.idPedido
              this.cobrancaAsaasCartao.empresaId = this.empresa.id
              axios.get(`https://api.ipify.org/?format=json`).then(response => {
                if (response.data) {
                  try {
                    this.cobrancaAsaasCartao.remoteIp = response.data.ip
                  } catch (error) {
                    this.cobrancaAsaasCartao.remoteIp = '127.0.0.1'
                  }
                } else {
                  this.cobrancaAsaasCartao.remoteIp = '127.0.0.1'
                }
              })
              // inserindo dados do responśavel do cartão de crédito no objeto de pagamento
              this.cobrancaAsaasCartao.creditCardHolderInfo.cpfCnpj = this.cobrancaAsaasCartao.creditCard.cpfCnpj
              this.cobrancaAsaasCartao.creditCardHolderInfo.name = this.convidado.nome
              this.cobrancaAsaasCartao.creditCardHolderInfo.phone = this.convidado.whatsapp.replace(/[^\d]+/g,'')
              await axios.post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaasCartao).then(res => {
                if (res.data.cobranca.status == 'CONFIRMED') {
                  this.pedido.statusPagamento = "PAGO"
                  this.pedido.codigoTransacao = res.data.cobranca.invoiceUrl
                  this.atualizaPedido(this.finalizaInscricao)
                }
              })
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Transação não autorizada. Verifique os dados informados e tente novamente ou utilize um outro cartão.","DESCULPE");
            }
          } else {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar pagamento, tente novamente!","DESCULPE");
          }
        } else {
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para continuar!", "ATENÇÃO")
        }
      },

      async criarClienteAsaas() {
        this.clienteAsaas.name = this.convidado.nome
        this.clienteAsaas.mobilePhone = this.convidado.whatsapp.replace(/[^\d]+/g,'')
        this.clienteAsaas.empresaId = this.empresa.id
        try {
          await axios.post(`${baseApiUrl}Pagamentos/criarCliente`, this.clienteAsaas).then(response => {
            if (response.data) {
              this.idClienteAsaas = response.data.id
            }
          })
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      async pagamentoBoleto() {
        this.isLoading = true
        await this.salvarPedido('BOLETO')
        await this.criarClienteAsaas()
        if (this.idPedido) {
          try {
            this.cobrancaAsaas.customer = this.idClienteAsaas
            this.cobrancaAsaas.value = parseFloat(this.pedido.valor.replace(',','.')).toFixed(2)
            this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
            this.cobrancaAsaas.billingType = 'BOLETO'
            this.cobrancaAsaas.description = 'Ref. aos presentes para ' + this.empresa.nome
            this.cobrancaAsaas.pedidoId = this.idPedido
            this.cobrancaAsaas.empresaId = this.empresa.id
            await axios.post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaas).then(res => {
              if (res.data) {
                this.pedido.codigoTransacao = res.data.cobranca.invoiceUrl
                this.atualizaPedido(this.finalizaInscricao)
                this.linkBoleto = res.data.cobranca.bankSlipUrl
                this.isLoading = true
                this.confirmacaoBoleto = true
              }
            })
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Problema encontrado ao gerar o boleto. Tente novamente mais tarde.","DESCULPE");
          }
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      abreBoleto() {
        window.open(this.linkBoleto)
      },

      async pagarPix() {
        this.isLoading = true
        await this.salvarPedido('PIX')
        await this.criarClienteAsaas()
        if (this.idPedido) {
          try {
            this.cobrancaAsaas.customer = this.idClienteAsaas
            this.cobrancaAsaas.value = (parseFloat(this.pedido.valor.replace(',','.'))).toFixed(2)
            this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
            this.cobrancaAsaas.billingType = 'PIX'
            this.cobrancaAsaas.description = 'Ref. aos presentes para ' + this.empresa.nome
            this.cobrancaAsaas.pedidoId = this.idPedido
            this.cobrancaAsaas.empresaId = this.empresa.id
            await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaas).then(response => {
              if (response.data) {
                this.pedido.codigoTransacao = response.data.cobranca.invoiceUrl
                this.qrCode64 = "data:image/jpeg;base64," + response.data.qrCode.encodedImage
                this.chaveCopiaeCola = response.data.qrCode.payload
                this.msgResultado = 'Pré-inscrição realizada com sucesso'
                this.pagamentoPix = true
                this.isLoading = false
                this.atualizaPedido()
                this.consultaPagamentoPix()
              }
            })
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao gerar pagamento. Tente novamente mais tarde.","DESCULPE");
          }
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      consultaPagamentoPix() {
        try {
          this.verificaPagamento = setInterval(function() {
            axios.post(`${baseApiUrl}Pagamentos/AsaasCobrancaConsulta`, {"pedidoId": this.idPedido, "empresaId": this.empresa.id}).then(res3 => {
              if (res3.data.status == 'RECEIVED') {
                this.pedido.statusPagamento = "PAGO"
                this.isLoading = true
                this.atualizaPedido(this.finalizaInscricao)
                clearInterval(this.verificaPagamento)
              }
            })
          }.bind(this), 5000)
        } catch (error) {
          clearInterval(this.verificaPagamento)
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Não foi possível verificar o pagamento, tente novamente!","DESCULPE");
        }
      },

      finalizaInscricao() {
        this.isLoading = false
        if (this.pedido.formaPagamento == 'CARTAO' || this.pedido.formaPagamento == 'PIX') {
          this.pagamentoPix = false
          this.dialog = true
        } else if (this.pedido.formaPagamento == 'BOLETO') {
          this.msgResultado = 'Pré compra realizada com sucesso!'
          this.confirmacaoBoleto = true
        }
      },

      closeDialog() {
        this.dialog = false
        this.pagamentoPix = false
        this.reloadPage()
        this.$validator.reset()
      },

      async pegaParametrosUrl() {
        this.carregamento = 'CARREGANDO'
        this.isLoading = true
        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          var paramArray = {};                    // Criar objeto que vai conter os parametros
          for (var i=0; i<params.length; i++) {   // Passar por todos os parametros
            var param = params[i].split('=');     // Dividir os parametros chave e valor
            paramArray[param[0]] = param[1];      // Adicionar ao objeto criado antes
          }
          if (paramArray['convidado']) {
            this.carregaConvidado(paramArray['convidado'])
          }
        }
        this.isLoading = false
      },

      async carregaConvidado(codConvidado) {
        if (codConvidado.length == 24) {
          await axios.get(baseApiUrl + 'Convidados/' + codConvidado + '?filter={"include":["userValidatorCheckin"]}').then(response => {
            if (response.data) {
              this.convidado = response.data
            }
          })
        } else {
          await axios.get(baseApiUrl + 'Convidados?filter={"where":{"codigo":"' + codConvidado + '"}, "include":"userValidatorCheckin"}').then(response => {
            if (response.data) {
              this.convidado = response.data[0]
            }
          })
        }
        this.carregaEmpresa(this.convidado.empresaId)
        this.carregaPresentesConvidado(this.convidado.id)
      },

      async carregaPresentes(id) {
        await axios.get(baseApiUrl + 'Produtos?filter={"where":{"and":[{"empresaId":"' + id + '"},{"status":"ativo"}]}}')
        .then(response => {
          if (response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.presentes.push({
                "descricao": response.data[i].descricao,
                "detalhes": response.data[i].detalhes,
                "preco": response.data[i].preco,
                "status": response.data[i].status,
                "urlImagem": response.data[i].urlImagem,
                "codigo": response.data[i].codigo,
                "empresaId": response.data[i].empresaId,
                "categoriaId": response.data[i].categoriaId,
                "created": response.data[i].created,
                "id": response.data[i].id,
                "naLista": false
              })
            }
          }
        })
        .catch(() => {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao confirmar token, tente novamente", "DESCULPE")
        })
      },

      async carregaPresentesConvidado(id) {
        await axios.get(baseApiUrl + 'Pedidos?filter={"where":{"and":[{"convidadoId":"' + id + '"},{"statusPagamento":"PAGO"}]}}')
        .then(response => {
          if (response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.horaPresentes.push({
                "id": i+1,
                "horaPresente": 'Presenteou em ' + this.transformaData(response.data[i].created, 'DD/MM/YYYY') + ' às ' + this.transformaData(response.data[i].created, 'HH:mm:ss') + '.'
              })
            }
          }
        })
      },

      async confirmaPresenca(confirmacao) {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#0288D1","Obrigado por sua confirmação!","INFORMAÇÃO");
        this.convidado.confirmacao = confirmacao
        this.convidado.horaConfirmacao = moment().toISOString()
        await axios.patch(baseApiUrl + 'Convidados', this.convidado)
        .then(response => {
          if (response.data) {
            this.convidado = response.data
          }
        })
        .catch(() => {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao atualizar confirmação", "DESCULPE")
        })
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      adicionaItem(item) {
        let produto = {
          "produtoId": item.id,
          "descricao": item.descricao,
          "urlImagem": item.urlImagem,
          "detalhes": item.detalhes,
          "preco": item.preco
        }
        this.pedido.itensPedido.push(produto)
        for (let i = 0; i < this.presentes.length; i++) {
          if (item.id == this.presentes[i].id) {
            this.presentes[i].naLista = true
          }
        }
      },

      removeItem(item) {
        if (this.pedido.itensPedido.length > 0) {
          for (let i = 0; i < this.pedido.itensPedido.length; i++) {
            if (this.pedido.itensPedido[i].produtoId == item.id) {
              this.pedido.itensPedido = this.pedido.itensPedido.filter(prod => prod.produtoId != item.id)
            }
          }
          for (let i = 0; i < this.presentes.length; i++) {
            if (item.id == this.presentes[i].id) {
              this.presentes[i].naLista = false
            }
          }
        }
      },

      calculaValorParcelado(valorPresente, quantidade) {
        /* let resultado = parseFloat(valorPresente.replace(',','.')) / quantidade
        let conta = parseFloat(resultado) + (parseFloat(resultado * (this.empresa.porcentagemCobrada / 100)))
        return conta.toFixed(2).replace('.',',') */
        let parcelas = []
        for (let i = 0; i < this.empresa.quantidadeParcelas; i++) {
          if ((i + 1) == 1) {
            parcelas.push({
              "value": parseFloat(valorPresente.replace(',','.')).toFixed(2)
            })
          } else if ((i + 1) == 2) {
            parcelas.push({
              "value": (parseFloat(parcelas[i-1].value) + parseFloat(parcelas[i-1].value * ((this.empresa.porcentagemCobrada + (this.empresa.porcentagemCobrada / 2)) / 100))).toFixed(2).replace(',','.')
            })
          } else {
            parcelas.push({
              "value": (parseFloat(parcelas[i-1].value) + parseFloat(parcelas[i-1].value * (this.empresa.porcentagemCobrada / 100))).toFixed(2).replace(',','.')
            })
            if ((i + 1) == quantidade) {
              break
            }
          }
        }
        return (parcelas[quantidade - 1].value / quantidade).toFixed(2).replace('.',',')
      },

      continuaCompra() {
        this.dialogoCompra = true
        this.exibeFooterResumo = true
        this.criarAnosVencimento()
        this.criarParcelas()
      },

      criarAnosVencimento() {
        let anoAtual = new Date().toISOString().substring(0, 4)
        let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14

        while ( anoAtual <= anoFinal ) {
          this.anosVencimento.push((anoAtual++).toString());
        }
      },

      async salvarPedido(formaPagamento) {
        var vm = this;
        this.pedido.formaPagamento = formaPagamento
        this.pedido.empresaId = this.empresa.id
        this.pedido.convidadoId = this.convidado.id
        this.pedido.created = moment().format().replace('-03:00','.000Z')
        await axios.post(`${baseApiUrl}Pedidos/replaceOrCreate`, this.pedido)
        .then(response => {
          if (response.status == 200) {
            this.idPedido = response.data.id
          } else {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao salvar os presentes, tente novamente!", "DESCULPE")
          }
        }).catch(() => {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao salvar os presentes, tente novamente", "DESCULPE")
        })
      },

      dialogoPedeCPF(formaPagamento) {
        this.formaPagamento = formaPagamento
        this.dialogoInformarCPF = true
      },

      prosseguirPagamento() {
        var vm = this;
        if (!this.clienteAsaas.cpfCnpj) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Informe seu CPF para continuar", "ATENÇÃO")
        } else if (!CpfValidate(this.clienteAsaas.cpfCnpj)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Informe um CPF válido", "ATENÇÃO")
        } else {
          if (this.formaPagamento == 'PIX') {
            this.pagarPix()
          } else {
            this.pagamentoBoleto()
          }
          this.dialogoInformarCPF = false
        }
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #424242, #616161);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  a {
    text-decoration: none
  }
</style>
